__turbopack_context__.v({
  "button": "yFWQBG_button",
  "buttonWrapper": "yFWQBG_buttonWrapper",
  "lightbox": "yFWQBG_lightbox",
  "lightboxCloseButton": "yFWQBG_lightboxCloseButton",
  "lightboxWrapper": "yFWQBG_lightboxWrapper",
  "textWrapper": "yFWQBG_textWrapper",
});
